import React from "react"

export const withBadge = Component => ({ componentName = "Badge", text, colour }: any) => {
  Component.displayName = componentName
  return <Component contents={text?.split(" ") || null} colour={colour} />
}
